export default "__VITE_ASSET__gwdU3ie4__"